$(function () {
    $(".slider-list").slick({
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 700,
      centerMode: false,
      dots: true,
      arrows: false,
      useTransform: false,
      slidesToShow: 1,
      slidesToScroll: 1,
  });
});

window.addEventListener('DOMContentLoaded', function() {
  const descSection = document.querySelector('.desc');
  const courseSection = document.querySelector('.course');
  const drinkSection = document.querySelector('.drink');
  const menuSection = document.querySelector('.menu');
  const accessSection = document.querySelector('.access');

  const item01 = document.querySelector('.item01');
  const item02 = document.querySelector('.item02');
  const item03 = document.querySelector('.item03');
  const item04 = document.querySelector('.item04');
  const item05 = document.querySelector('.item05');

  window.addEventListener('scroll', function() {
    const scrollY = window.scrollY;

    if (scrollY >= descSection.offsetTop && scrollY < courseSection.offsetTop) {
      item01.classList.add('active');
    } else {
      item01.classList.remove('active');
    }

    if (scrollY >= courseSection.offsetTop && scrollY < drinkSection.offsetTop) {
      item02.classList.add('active');
    } else {
      item02.classList.remove('active');
    }

    if (scrollY >= drinkSection.offsetTop && scrollY < menuSection.offsetTop) {
      item03.classList.add('active');
    } else {
      item03.classList.remove('active');
    }

    if (scrollY >= menuSection.offsetTop && scrollY < accessSection.offsetTop) {
      item04.classList.add('active');
    } else {
      item04.classList.remove('active');
    }

    if (scrollY >= accessSection.offsetTop) {
      item05.classList.add('active');
    } else {
      item05.classList.remove('active');
    }
  });
});